import { Location } from 'react-native-get-location';

export const getUserLocation = (): Promise<Location> => {
  // TODO: implement support for getting user location on web platform
  // consider submitting a PR to 'react-native-get-location'
  throw 'Not supported';
};
